import {AxiosError, AxiosResponse} from 'axios';
import {useMutation, UseMutationOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';
import * as cache from '@eksab/cache';
import {useFetchMe, useSetMeQueryData} from '@eksab/hooks';

type Params = {
  phone_number: string;
  otp: string;
};

export const useChangePhoneNumberMutation = (options?: UseMutationOptions<void, AxiosError, Params>) => {
  const fetchMe = useFetchMe();
  const setMe = useSetMeQueryData();

  return useMutation<void, AxiosError, Params>(
    (params) =>
      api.post<Params, AxiosResponse<void>>('/v2/profile/phone-number/change', params).then((res) => res.data),
    {
      ...options,
      onSuccess: async (...params) => {
        try {
          const me = await fetchMe();
          cache.setMe(me);
          setMe(me);

          options?.onSuccess?.(...params);
        } catch (e) {
          console.error(e);
        }
      },
    },
  );
};
